import { ReactNode, useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import { CheckboxInput } from 'src/components/checkbox_input';
import { FeedbackPopup, FeedbackType } from 'src/components/feedback_popup';
import { Caution } from 'src/components/icons/caution';

export type TempusMissingClinicalVariablesSaveOptions = {
  sendTempusMissingClinicalVariablesEmail: boolean;
};

interface TempusMissingClinicalVariablesDialogProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (
    options: TempusMissingClinicalVariablesSaveOptions,
  ) => Promise<void>;
}

const TempusMissingClinicalEmailCheckboxLabel = (): ReactNode => (
  <Typography variant='body2' component='div' sx={{ textAlign: 'left' }}>
    Email Tempus about missing variables (This action will move the order to
    Clin Vars Pending - Tempus status)
  </Typography>
);

export const TempusMissingClinicalVariablesDialog = ({
  open,
  onClose,
  onSubmit,
}: TempusMissingClinicalVariablesDialogProps) => {
  const [notifyTempus, setNotifyTempus] = useState(false);

  useEffect(() => {
    if (open) {
      setNotifyTempus(false);
    }
  }, [open]);

  const handleConfirm = async () => {
    await onSubmit({ sendTempusMissingClinicalVariablesEmail: notifyTempus });
    onClose();
  };

  return (
    <FeedbackPopup
      data={{
        primaryButtonText: 'SAVE',
        secondaryButtonText: 'CANCEL',
        title: 'Save order',
        subtitle: 'Some clinical variables pending!',
        type: FeedbackType.Primary,
        icon: Caution,
      }}
      isDialogOpen={open}
      onPrimaryButtonClick={handleConfirm}
      onSecondaryButtonClick={onClose}
      handleDialogClose={onClose}
      primaryButtonTestId='tempus-missing-clinical-save-button'
      secondaryButtonTestId='tempus-missing-clinical-cancel-button'
      dialogTestId='tempus-missing-clinical-dialog'
    >
      <Box sx={{ mt: 2 }}>
        <CheckboxInput
          checked={notifyTempus}
          onChange={setNotifyTempus}
          label={<TempusMissingClinicalEmailCheckboxLabel />}
          labelVerticalAlign='center'
        />
      </Box>
    </FeedbackPopup>
  );
};
